import config from '@/config'

/**
 * 地図描画処理クラス
 *
 * @class Map
 */
class Map {
  constructor (mapDivId, mapType, zoom, lat, lng, zoomable, movable) {
    // 地図を表示するdivのid
    this.mapDivId = mapDivId
    // マップタイプ
    this.mapType = mapType
    // zipsAPIの地図オブジェクト
    this.map = null
    // 地図の中心位置
    this.centerLat = lat
    this.centerLng = lng
    // 地図のズームレベル
    this.zoomLevel = zoom
    // ズーム可否
    this.zoomable = zoomable

    // 14 35.6813821,139.7660968
    // 地図中心位置を伝播させる関数
    this.setMapCenterValue = null
    // 地図のズームレベルを伝播させる関数
    this.setMapZoomValue = null
    // 地図の中心位置を地図から取得する関数
    this.initGetCenter = null
    // 地図のズームレベルを地図から取得する関数
    this.initGetZoom = null
    // 縮尺ボタン
    this.zoomButton = null
    // 地図のクリック地点の緯度経度を伝播させる関数
    this.setMapClickLatLngValue = null
    this.movable = movable
    this.clinkPoint = null
    this.clickLatLng = null
    this.clickDCN = null
  }

  /**
   * 地図初期化
   *
   * @memberof Map
   */
  initMap () {
    return new Promise((resolve, reject) => {
      const ZMALoader = window.ZMALoader

      ZMALoader.setOnLoad((mapOptions, error) => {
        if (error) {
          console.error(error)
          reject(error)
        }

        const ZDC = window.ZDC

        // 地図タイプを指定
        mapOptions.zipsMapType = this.mapType
        mapOptions.center = new ZDC.LatLng(this.centerLat, this.centerLng)
        this.setMapCenterValue(this.centerLat, this.centerLng)
        // ズームレベルを指定
        mapOptions.maxZoom = config.mapZoomLevels[config.mapZoomLevels.length - 1]
        mapOptions.minZoom = config.mapZoomLevels[0]
        mapOptions.zoom = this.zoomLevel
        mapOptions.mouseWheelReverseZoom = true
        mapOptions.movable = this.movable
        mapOptions.zoomable = this.zoomable
        mapOptions.rotatable = true
        this.setMapZoomValue(this.zoomLevel)
        // 地図オブジェクトを生成
        this.map = new ZDC.Map(
          document.getElementById(this.mapDivId),
          mapOptions,
          () => {
            this.addMapOption()
            resolve()
          },
          () => {
            const error = new Error()
            reject(error)
          }
        )
      })
    })
  }

  /**
   * 地図のオプション（イベント）を設定する
   *
   * @memberof Map
   */
  addMapOption () {
    // const ZDC = window.ZDC
    // ズームレベルが変更されたときに画面の表示に反映する（少数点以下切り捨てない）
    this.initGetZoom = () => {
      this.zoomLevel = this.map.getZoom()
      this.setMapZoomValue(this.zoomLevel)
      this.getClickLatLng(null, null)
    }
    this.map.addEventListener('zoom_changed', this.initGetZoom)

    // 地図の中心位置が変更されたときに画面の表示に反映する
    this.initGetCenter = () => {
      const centerPosition = this.map.getCenter()
      this.centerLat = centerPosition.lat
      this.centerLng = centerPosition.lng
      this.setMapCenterValue(this.centerLat, this.centerLng)
    }
    this.map.addEventListener('center_changed', this.initGetCenter)

    /* 地図を右クリックしたときの動作 */
    // this.map.addEventListener('rightclick', (event) => {
    // this.getClickLatLng(event.point, event.latlng) // ← this は外側の this を指す
    // })

    // コンパス
    // this.map.addControl(new ZDC.Compass('top-right', new ZDC.Point(-13, 80)))

    // this.map.addEventListener('click', function (event) {
    //   // ★イベント発生時の値を取得 event={String(イベント名), LatLng(緯度経度), Point(ピクセル座標)}
    //   // 例 event = {type: "click", latlng: f, point: a}
    //   this.getClickLatLng(event.point)
    // })
  }

  /**
   * mapイベントを削除し、インスタンスを解放する
   *
   * @memberof Map
   */
  destroyed () {
    if (!this.map) {
      return
    }
    this.map.removeEventListener('zoom_changed', this.initGetZoom)
    this.map.removeEventListener('center_changed', this.initGetCenter)
    // WebGLが保持するネイティブリソースを解放する
    this.map.destruct()
  }

  /**
   * 地図中心位置の値を受け渡す関数を登録するリスナー
   *
   * @param {object} listener 呼び出し元のクラスに地図中心位置を渡す関数
   * @memberof Map
   */
  setMapCenterListener (listener) {
    this.setMapCenterValue = listener
  }

  setMapZoomListener (listener) {
    this.setMapZoomValue = listener
  }

  setMapClickLatLngListener (listener) {
    this.setMapClickLatLngValue = listener
  }

  setCenterMarker () {
    // 地図中心マーカーの設定
    const centerMarker = new window.ZDC.CenterMarker()
    this.map.addControl(centerMarker)
  }

  wait (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  setCompass () {
    const ZDC = window.ZDC
    // コンパス
    this.map.addControl(new ZDC.Compass('top-right', new ZDC.Point(-13, 80)))
  }

  async getClickLatLng (point, latlng) {
    if (point == null && latlng == null) {
      // ズームレベル変更時
      await this.wait(500)
      if (this.clickDCN == null) {
        // DCN非表示時
        return
      }
      // return
    } else {
      // クリック時
      this.clinkPoint = point
      this.clickLatLng = latlng
    }
    const dcnpoint = this.map.latlngToPoint(this.clickLatLng)
    const dcn = this.map.getDCN(dcnpoint)
    this.clickDCN = dcn
    // console.log(this.clinkPoint)
    // console.log(this.clickLatLng)
    this.setMapClickLatLngValue(this.clickDCN, this.clickLatLng)
  }

  addDCNWidget (dcn, latlng) {
    this.map.removeAllWidgets()
    /* ★吹き出しを作成 */
    const ZDC = window.ZDC
    // const dcnText = dcn
    //   .map(dcn => [dcn.name, dcn.dcn, dcn.type].join(','))
    //   .join('\n')
    const widget = new ZDC.Popup(
      latlng,
      {
        htmlSource: dcn,
        closeButton: false
      }
    )
    /* ★吹き出しを追加 */
    this.map.addWidget(widget)
  }

  removeAllWidgets () {
    this.map.removeAllWidgets()
  }

  resetClickDCN () {
    this.clickDCN = null
  }

  // showAlert (text) {
  //   alert(text)
  // }

  /**
   * 地図の中心位置を変更する
   *
   * @param {number} lat 緯度
   * @param {number} lng 経度
   * @memberof Map
   */
  moveTo (lat, lng) {
    this.centerLat = lat
    this.centerLng = lng
    const ZDC = window.ZDC
    this.map.setCenter(new ZDC.LatLng(this.centerLat, this.centerLng))
  }

  /**
   * 地図のズームレベルを変更する
   *
   * @param {number} zoomLevel 変更先のズームレベル
   * @memberof Map
   */
  zoomMap (zoomLevel) {
    this.zoomLevel = zoomLevel
    this.map.setZoom(this.zoomLevel)
  }

  movableMap (movable) {
    this.movable = movable
  }

  getZoomLevel () {
    return this.map.getZoom()
  }

  getCenterPosition () {
    return this.map.getCenter()
  }

  setZoom (zoom) {
    this.map.setZoom(zoom)
  }

  setCenter (lat, lng) {
    const ZDC = window.ZDC
    this.map.setCenter(new ZDC.LatLng(lat, lng))
  }

  removeZoomButton () {
    this.map.removeControl(this.zoomButton)
  }

  setHeading (heading) {
    this.map.setHeading(heading)
  }

  /**
   * 住所をフリーワードで検索する
   *
   * @param {string} keyWord キーワード
   * @returns 検索結果のオブジェクト
   * @memberof Map
   */
  searchAddress (keyWord) {
    return new Promise((resolve, reject) => {
      const param = {
        zis_authkey: config.zipsApi.key,
        zis_authtype: config.zipsApi.authType,
        word: keyWord,
        word_match_type: 3,
        limit: 10
      }

      try {
        this.map.requestAPI('/api/zips/general/address', param, function (res) {
          resolve(res.ret)
        })
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * 地図のデザインを変更する
   *
   * @param {array} designs 変更するデザインデータの配列
   * @memberof Map
   */
  updateDesign (designs) {
    const defs = {
      poly: [],
      line: [],
      note: []
    }
    designs.forEach((design) => {
      let tmp
      if (design.fcc) {
        tmp = ['DCN:' + design.fcc, design.def, design.scale]
      } else if (design.zid) {
        tmp = ['ZID:' + design.zid, design.def, design.scale]
      }

      if (design.type === 'poly') {
        defs.poly.push(tmp)
        return
      }
      if (design.type === 'line') {
        defs.line.push(tmp)
        return
      }
      if (design.type === 'note') {
        defs.note.push(tmp)
      }
    })

    return this.map.updateStyle(defs)
  }

  updateStyleMap (defs) {
    return this.map.updateStyle(defs)
  }

  changeFont (font) {
    console.log(font)
    this.map.reinitialize({ fontName: font }, () => {}, () => {})
  }

  setGoogleMap () {
    const designData = require('./design_gmap.json')
    return this.updateDesign(designData)
  }

  setWhiteMap () {
    const designData = require('./design_white.json')
    return this.updateDesign(designData)
  }

  setGoogleMapKids () {
    const designData = require('./design_gmap_kids.json')
    return this.updateDesign(designData)
  }

  setWhiteKidsMap () {
    const designData = require('./design_white_kids.json')
    return this.updateDesign(designData)
  }
}

export default Map
